import { FetchHttpClient } from 'effect/http';
import { Layer, Logger, ManagedRuntime, References } from 'effect';
import { globalValue } from '@listening/utils/global-value';
import { ApiClient } from '@listening/api-contract/api-client-tag';
import { WebCryptoLive } from '@listening/frontend/crypto/web-crypto';
import { clientEnv } from '@/env';

// Client: HTTP requests via same-origin /api (CloudFront routes to k8s).
// The contract already includes /api as a prefix, so no baseUrl needed here.
const HttpApiClientLive = ApiClient.layer();

// The client's log configuration lives on the runtime, not in a facade: every
// Effect program in the browser — shared packages included — gets the same
// level, format and bindings. Only production quiets down; a client-side
// failure that leaves no trace is what made this unusable for debugging.
const LoggerLive = Layer.mergeAll(
  Logger.layer([Logger.consolePretty()]),
  Layer.succeed(
    References.MinimumLogLevel,
    clientEnv.mode === 'production' ? 'Warn' : 'Debug',
  ),
  Layer.succeed(References.CurrentLogAnnotations, {
    app: '@listening/start',
    env: clientEnv.mode,
  }),
);

export const clientRuntime = globalValue('Listening/ClientRuntime', () =>
  ManagedRuntime.make(
    // FetchHttpClient: the ApiClient's transport, and plain HTTP for shared
    // programs that aren't ApiClient calls (doc-pack ranged reads) —
    // AppRuntime requires it in R.
    HttpApiClientLive.pipe(
      Layer.provideMerge(FetchHttpClient.layer),
      Layer.provideMerge(WebCryptoLive),
      Layer.provideMerge(LoggerLive),
    ),
  ),
);
